module.exports = __webpack_public_path__ + "static/media/Statua_057.362f02f3.jpg";